import { DEFAULT_COLUMNS as DEFAULT_TASKLIST_COLUMNS } from "../../task-list/lib/constants";
import { COLUMN_KEYS } from "./constants";

const getValue = (defaultValue, storedValue, columnPredefinedValue, hasStoredColumns) => {
    if (defaultValue) {
        return defaultValue;
    }

    return hasStoredColumns ? !!storedValue : columnPredefinedValue;
};

export const getUserColumns = (defaultValue) => {
    const storedColumns = localStorage.getItem("task-list-columns-duplicatestaging");
    const storedColumnKeys = storedColumns || [];

    return Object.keys(DEFAULT_TASKLIST_COLUMNS).reduce((columns, columnKey) => {
        const isVisible = COLUMN_KEYS.includes(columnKey);

        if (!isVisible) {
            return columns;
        }

        const storedValue = storedColumnKeys.includes(columnKey);
        const column = DEFAULT_TASKLIST_COLUMNS[columnKey];
        columns[columnKey] = {
            ...column,
            value: getValue(defaultValue, storedValue, column.value, !!storedColumns),
        };

        return columns;
    }, {});
};
